import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const outsideFaksSignatureRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/outside_faks_signature',
  validateSearch: z.object({
    token: z.preprocess((v) => (v === undefined ? undefined : `${v}`), z.string()),
  }),
}).lazy(() =>
  import('pages/shared/OutsideFaksSignaturePage/OutsideFaksSignaturePage').then((d) => d.Route)
);
